module.exports = __webpack_public_path__ + "static/img/cert-continue.21ec87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/cert-continue.png
// module id = OUKj
// module chunks = 1